module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/sb-account-grid/sb-account-grid.component.css
// module id = ./src/app/master-account/sb-account-grid/sb-account-grid.component.css
// module chunks = main